import {styled} from "@mui/material";

export const PhoneInputContainer = styled('div')(({theme}) => {
    return {
        '& .form-control': {
            height: '60px',
            width: '100%',
            transition: '',

            '&:focus': {
                borderColor: theme.barekam.green,
                borderWidth: '2px',
                boxShadow: 'unset'
            }
        },
        '& .special-label': {
            left: '10px',
            fontSize: '0.75rem',
            color: `${theme.palette.text.primary}96`,
            '&::last-letter': {
                color: 'red'
            }
        }
    }
});